module.exports = __webpack_public_path__ + "static/media/notebookExplore.9d996c1a.png";